import React from "react";
import ChartIndexSelector from "../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartIndexSelector";
import moment from "moment-timezone";
import { toTitleCase } from "../../../../Dashboard/Charts/utils";

const InstagramPageSelector = ({ pageList, setSelectedPage, selectedPage, widgetContainerRef }) => {
    let index = selectedPage.value;
    let formattedList = [];
    pageList.forEach((ele) => {
        let obj = {};
        let newStatus = ele.status;
        if (ele.status === "Active") {
            let a = moment(new Date());
            let b = moment(ele.token_expires_at);
            if (b.diff(a, "days") < 7) {
                newStatus = "Expiring soon";
            }
        }
        obj["label"] = `${toTitleCase(ele.page_username)} (${newStatus})`;
        obj["id"] = ele.id;
        obj["value"] = ele.page_id;
        obj["access_token"] = ele.access_token;
        obj["expiry_date"] = ele.token_expires_at;
        obj["handler"] = ele.page_username;

        formattedList.push(obj);
    });

    const handlePageChange = (d) => {
        let val = pageList.find((ele) => ele.page_id == d);
        let obj = {};
        let newStatus = val.status;
        if (val.status === "Active") {
            let a = moment(new Date());
            let b = moment(val.token_expires_at);
            if (b.diff(a, "days") < 7) {
                newStatus = "Expiring soon";
            }
        }
        obj["label"] = `${val.page_username} (${newStatus})`;
        obj["id"] = val.id;
        obj["value"] = val.page_id;
        obj["access_token"] = val.access_token;
        obj["expiry_date"] = val.token_expires_at;
        obj["handler"] = val.page_username;
        setSelectedPage(obj);
    };

    return (
        <div className="chart-item-name">
            <ChartIndexSelector
                isInstagram
                currentName={selectedPage.label}
                currentIndex={index}
                options={formattedList}
                onIndexChange={(e) => handlePageChange(e)}
                widgetContainerRef={widgetContainerRef}
            />
        </div>
    );
};

export default InstagramPageSelector;
